class CartDrawerHandler {
    constructor() {
      this.cartDrawer = document.getElementById('CartDrawer');
      if (!this.cartDrawer) return;
      
      this.initElements();
      this.initState();
      this.bindEvents();
    }

    initElements() {
      const selectors = {
        modalElement: '.nova-poshta-modal',
        overlayElement: '.nova-poshta-modal .fixed-modal',
        openPoshta: '.drawer__footer-top .nova-poshta-button',
        closePoshta: '.drawer__footer-top .nova-poshta-modal button.close',
        typeDeliveryRadio: 'input[name="id"]',
        branchRadio: 'input[id="type-branch"]',
        courierRadio: 'input[id="type-courier"]',
        checkoutButtonWrapper: '.drawer__footer-buttons',
        checkoutButton: 'button[name="checkout"]'
      };

      Object.entries(selectors).forEach(([key, selector]) => {
        if (key === 'typeDeliveryRadio') {
          this[key] = this.cartDrawer.querySelectorAll(selector);
        } else {
          this[key] = this.cartDrawer.querySelector(selector);
        }
      });

      this.checkoutButtonText = this.checkoutButton?.querySelector('.btn-text');
      this.hoverTimeout = null;
      this.isModalOpen = false;
    }

    initState() {
      if (!this.checkoutButton) return;
      
      //this.checkoutButton.disabled = true;
      
      const deliveryType = localStorage.getItem('delivery_type') || 'branch';
      this.setDeliveryType(deliveryType);
    }

    setDeliveryType(type) {
      localStorage.setItem('delivery_type', type);
      this.cartDrawer.setAttribute('data-delivery', type);
      
      if (this.branchRadio && this.courierRadio) {
        this.branchRadio.checked = type === 'branch';
        this.courierRadio.checked = type === 'courier';
      }
    }

    updateCheckoutText(template) {
      if (this.checkoutButtonText) {
        this.checkoutButtonText.innerHTML = template;
      }
    }

    getDeliveryCheckoutText() {
      if (this.checkoutButton?.disabled) {
        const deliveryType = localStorage.getItem('delivery_type');
        const radio = deliveryType === 'branch' ? this.branchRadio : this.courierRadio;
        return radio?.getAttribute('data-checkout-text') || '';
      } else {
        return NP.buttonTextCompany;
      }
    }

    getDefaultCheckoutText() {
      return NP.buttonTextCompany;
    }

    getHoverCheckoutText() {
      return NP.buttonTextDelivery;
    }

    bindEvents() {
      // Delivery type change
      this.typeDeliveryRadio?.forEach(radio => {
        radio.addEventListener('change', () => {
          const deliveryType = radio.getAttribute('data-type');
          this.setDeliveryType(deliveryType);
          this.updateCheckoutText(radio.getAttribute('data-checkout-text'));
        });
      });

      // Modal open
      this.openPoshta?.addEventListener('click', () => {
        console.log('Opening Nova Poshta modal');
        this.cartDrawer.classList.add('nova-poshta-open');
        this.isModalOpen = true;
        this.updateCheckoutText(this.getDeliveryCheckoutText());
      });

      // Modal close
      this.closePoshta?.addEventListener('click', () => {
        this.cartDrawer.classList.remove('nova-poshta-open', 'nova-poshta-open__start');
        this.isModalOpen = false;
        this.updateCheckoutText(this.getDefaultCheckoutText());
      });

      // Checkout button click
      this.checkoutButtonWrapper?.addEventListener('click', () => {
        if (this.isModalOpen || !this.checkoutButton?.disabled) return;
        this.openPoshta?.click();
      });

      // Overlay click
      this.cartDrawer.addEventListener('click', (event) => {
        if (event.target === this.overlayElement && this.isModalOpen) {
          this.closePoshta?.click();
          this.modalElement?.removeAttribute('open');
          this.modalElement?.setAttribute('hidden', '');
          this.modalElement?.setAttribute('inert', '');
          this.modalElement?.removeAttribute('active');
        }
      });

      
      // Hover effects
      this.checkoutButtonWrapper?.addEventListener('mouseenter', () => {
        if (this.isModalOpen || !this.checkoutButton?.disabled) return;
        
        this.checkoutButton?.classList.add('color-accent');
        this.updateCheckoutText(this.getHoverCheckoutText());
        
        this.hoverTimeout = setTimeout(() => {
          this.checkoutButton?.classList.remove('color-accent');
          if (!this.isModalOpen) {
            this.updateCheckoutText(this.getDefaultCheckoutText());
          }
        }, 3000);
      });

      this.checkoutButtonWrapper?.addEventListener('mouseleave', () => {
        if (this.isModalOpen) return;
        
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
        
        this.checkoutButton?.classList.remove('color-accent');
        this.updateCheckoutText(this.getDefaultCheckoutText());
      });
    }

    destroy() {
      // Очищаємо таймаути
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }

      // Видаляємо event listeners з радіо-кнопок
      this.typeDeliveryRadio?.forEach(radio => {
        const newRadio = radio.cloneNode(true);
        radio.parentNode?.replaceChild(newRadio, radio);
      });

      // Видаляємо event listeners з інших елементів
      const elementsToClean = [
        //this.openPoshta,
        //this.closePoshta,
        //this.checkoutButtonWrapper
      ];

      elementsToClean.forEach(element => {
        if (element) {
          const newElement = element.cloneNode(true);
          element.parentNode?.replaceChild(newElement, element);
        }
      });

      // Очищаємо посилання на елементи
      this.cartDrawer = null;
      this.modalElement = null;
      this.overlayElement = null;
      this.openPoshta = null;
      this.closePoshta = null;
      this.typeDeliveryRadio = null;
      this.branchRadio = null;
      this.courierRadio = null;
      this.checkoutButtonWrapper = null;
      this.checkoutButton = null;
      this.checkoutButtonText = null;
      
      console.log('CartDrawerHandler destroyed');
    }
  }
